import firebase, {
    create
} from "../../services/firebase";
import {
    mapActions,
    mapGetters
} from "vuex";
import Dates from "../../mixins/date";
import {
    MEMBER_STATUS,
    ROOM_TYPE,
    MEMBER_TYPE
} from "@/constants/discussion";
import chatService from "../../services/chat";
import {
    FIREBASE_ROOT_REF
} from "../../constants/discussion";
const Channel = () => import("./Channel/Channel.vue");
const ChannelItem = () => import("./ChannelItem/ChannelItem.vue");
const Room = () => import("./Room/Room.vue");
import _ from "lodash";
import conditionHelper from "../../helpers/condition";
import supportBusinessService from '../../services/supportBusiness'
import moment from 'moment';
import Utils from "../../mixins/Utils";
import {KEYWORDS} from '../../constants/support'
import { query, where, orderBy, limit } from "firebase/firestore";  

const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");
export default {
    components: {
        Channel,
        ChannelItem,
        Room,
        SectionTitle
    },

    mixins: [Dates,Utils],
    data() {
        return {
            formatedMissions: [],
            conversationList: [],
            firebaseConversations: [],
            selectedRoom: null,
            isLoadingConversation: true,
            infoAgency: {
                type: 1
            },
            showRoomChat: false,
            groupMissions: [],
            isFirstLoaded: true,
            agencyConversation: null,
            agencyInfo: {},
            isDisconnected: false,
            userStatus: Number,
            participantIds: [],
            ref: `${FIREBASE_ROOT_REF}/Conversations`,
            refUser: `${FIREBASE_ROOT_REF}/Users`,
            refMember: `${FIREBASE_ROOT_REF}/Members`,
            refMessage: `${FIREBASE_ROOT_REF}/Messages`,
            childRef: null,
            childRefUser: null,
            countContentConversationsInterval: undefined,
            updateConversation: false,
            isOpenRoomChat : false,
            arrayConversationInputMessage: [],
            isFirstTimeUseChat: false,
            isEnableChatCharte: false,
            tchatContent: '',
            isClickApplyTchat: false,
            isShowTchat: false,
            countNumberConversationsInterval:undefined,
            errorMessage: undefined,
            currentConversationRef: null,
            currentMess:{
                sentAt: null
            },
            loadingChatDetail:false,
            isChangeMessage:false
        }
    },
    computed: {
        ...mapGetters('mission', ['missions']),
        ...mapGetters('chat', ['conversations', 'pendingMsgs', "isReachChatIcon","chatSettings"]),
        ...mapGetters("auth", {
            user: 'getUser'          
        }),
        userId() {
            return JSON.parse(localStorage.getItem("user")).pkAdv;
        },
        userCrfId() {
            return JSON.parse(localStorage.getItem("user")).pkCrf;
        },
        userIdFirebase() {
            return `usr-${this.userCrfId}`;
        },
        isChatBoxShow() {
            return this.groupMissionValues.length ||
                this.agencyConversation
        },
        isBlocked() {
            return this.userStatus === MEMBER_STATUS.BLOCKED
        },
        groupMissionKeys() {
            return Object.keys(this.groupMissions);
        },
        groupMissionValues() {
            return Object.values(this.groupMissions).map( mission => {
                return mission.map(  item => {
                    return {
                        ...item,
                    }
                })
            });
        },
        isShowAgencyChannel() {
            return this.agencyConversation && conditionHelper('rcfchatadvagency')
        },
        isShowClientChannel() {
            return this.groupMissionValues.length && (conditionHelper('rcfchatadvteamclient') || conditionHelper('rcfchatadvteam'))
        }
    },
    async created() {
        /** 
         * Step 1: Generate firebase token to authenticate firebase
         * Step 2: Upsert Conversations, Members, Users to firebase
         * Step 3: Get conversations from adv-chat api
         * Step 4: Synchronize Messages with the conversations to firebase
         */
         await this.getBussinessSupport();
         await this.getChatCharter();
        chatService.generateFirebaseToken().then((token) => {
                if (token) {
                    firebase.auth().signInWithCustomToken(token.tokenFirebase).then(userCredential => {
                        var user = userCredential.user;
                        if (user) {
                            let numberListConversationsInterval = this.chatSettings && this.chatSettings.freqRefreshCountUnreadConsList ? this.chatSettings.freqRefreshCountUnreadConsList*1000 : 30000;
                            this.initConversation();
                            this.countContentConversationsInterval = setInterval(() => {
                                this.initConversation();

                            }, numberListConversationsInterval);
                            let numberUnreadMessageInterval = this.chatSettings && this.chatSettings.freqRefreshCountUnreadCons ? this.chatSettings.freqRefreshCountUnreadCons*1000 : 30000;
                            this.getNumberUnreadConversation(this.userCrfId);
                            this.countNumberConversationsInterval = setInterval(()=> {
                            this.getNumberUnreadConversation(this.userCrfId);
                            },numberUnreadMessageInterval);
                              

                            /** Listen disconnect event **/

                        }
                    }).catch((err)=> {
                        this.isLoadingConversation = false;
                        this.errorMessage = err.message || err;
                    });

                    if(token && token.success==false) {
                        this.isLoadingConversation = false;
                        let message = token.error || token;
                     switch(token.error) {
                        case 'user.notfound': {
                            message = this.$t('err_user_not_found');
                            break;
                        }
                        case 'auth.token.invalid': {
                            message = this.$t('err_token_is_not_valid');
                            break;
                        }


                     }
                     this.errorMessage = message;        
                    }
                }

               
            })
            .catch(err => {
                this.isLoadingConversation = false;
                let message = err.message ||err;
                switch(err.code) {
                   case 'user.notfound': {
                       message = this.$t('err_user_not_found');
                       break;
                   }
                   case 'auth.token.invalid': {
                    message = this.$t('err_token_is_not_valid');
                    break;
                   }
                }

                if(message =='signInWithCustomToken failed: First argument "token" must be a valid string.') {
                    message = this.$t('sign-in-with-token-invalid')
                }
                 this.errorMessage = message;        
                });
          
    },

    watch: {
        async conversations(res) {
            if (res.length) {
                let data =[];
                for(let i =0; i< res.length; i++) {
                    if(res[i]) {
                        data.push({
                            ...res[i],
                            lastTime: await this.getDisplayTime(res[i].id)
                        });
                    }
                }
             
              
                await this.groupAgencyTeam(data);
                await this.updateSelectedConvesationContent(false)
            } else {
                this.isLoadingConversation = false;
            }
        },
        selectedRoom(val) {
            if (val) {
             
                this.setCurrentConversation(val.detail)
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.countContentConversationsInterval);
        clearInterval(this.countNumberConversationsInterval);

    },
    destroyed() {},
    methods: {
        async getDisplayTime(convId) {
            let lastTime = await chatService.getLastTimeOfMessage(convId);
            return lastTime ?lastTime : '';
          },
    
        async updateSelectedConvesationContent(isScrollTop,defaultLoadMessage=20) {
            if(this.selectedRoom && this.selectedRoom.detail && (isScrollTop || this.currentMess.sentAt===null)) {
                const vue = this;
                let unreadMessageArray = []
                const contentReadAt = this.selectedRoom.detail.members.find((item) => item.idFirebase == this.userIdFirebase).contentReadAt;
                if(this.selectedRoom && this.selectedRoom.detail.unreadConversation  && contentReadAt!==null && !isScrollTop){
                    const snapShot = await firebase.database().ref(`Chats/Messages/${this.selectedRoom.detail.idFirebase}`).orderByChild('sentAt').startAt(new Date(contentReadAt).getTime()).once('value')
                    if(snapShot.val()) {
                        unreadMessageArray = vue.snapshotToArray(snapShot)
                       defaultLoadMessage = Math.ceil(unreadMessageArray.length/20)*20;
                    }
                }
                this.loadingChatDetail= !this.isChangeMessage;
                const ref =   firebase.database().ref(`Chats/Messages/${this.selectedRoom.detail.idFirebase}`);
               const conversationRef = 
               this.currentMess.sentAt!==null ? ref.orderByChild('sentAt').endBefore(this.currentMess.sentAt).limitToLast(defaultLoadMessage) : ref.orderByChild('sentAt').limitToLast(defaultLoadMessage);
               conversationRef 
               .on('value', snapshot=> {
                 if(!snapshot.val()) {
                    vue.loadingChatDetail=false;
                    vue.isLoadingConversation = false;
                    return;
                 }
               
                 if(snapshot.val()) {
                    const snapShotToArray = vue.snapshotToArray(snapshot)
                    if( vue.currentMess.sentAt===null ){
                        snapShotToArray.forEach(item => {
                            const index = this.firebaseConversations.findIndex((con)=> con.key === item.key);
                            if(vue.firebaseConversations.findIndex((con)=> con.key === item.key) < 0) {
                                vue.firebaseConversations.push(item)

                            }else {
                                vue.firebaseConversations[index] = {
                                    ...vue.firebaseConversations[index],
                                    ...item,
                                    sentAt: item.sentAt || vue.firebaseConversations[index].sentAt
                                };
                                if(!item.reactions){
                                    delete vue.firebaseConversations[index].reactions;
                                }
                            }
                           
                           ;
                        });
                    } else {
                        let i=snapShotToArray.length-1;
                        for(i; i >=0; i--) {
                            const index = vue.firebaseConversations.findIndex((con)=> con.key === snapShotToArray[i].key);
                            if(vue.firebaseConversations.findIndex((con)=> con.key === snapShotToArray[i].key) < 0) {
                                if( vue.isChangeMessage) {
                                    vue.firebaseConversations.push(snapShotToArray[i])
                                    vue.isChangeMessage = false
                                } else {
                                    vue.firebaseConversations.unshift(snapShotToArray[i])
                                
                                }
                            }else {

                                vue.firebaseConversations[index] = {
                                    ...vue.firebaseConversations[index],
                                    ...snapShotToArray[i],
                                    sentAt: snapShotToArray[i].sentAt || vue.firebaseConversations[index].sentAt
                                };
                                if(!snapShotToArray[i].reactions){
                                    delete vue.firebaseConversations[index].reactions;
                                }
                               
                            }
                        }
                    }


                    if(vue.selectedRoom && vue.selectedRoom.detail && vue.conversations.length > 0) {
                        const selectedRoomId = vue.selectedRoom.detail.id;
                        let result =   vue.conversations.find((item)=> 
                        item.id == selectedRoomId
                     )
                     result.isSelectedRoomchat = true;
                     if(vue.selectedRoom.detail.isFirstOpenRoomchat) {
                        result.isFirstOpenRoomchat = true;  
                     } else {
                        result.isFirstOpenRoomchat = false;

                     }
                     
                       if(result) {
                        vue.selectedRoom = {
                            detail: 
                            {
                                ...result,
                                ... vue.getContentIntoConvers(vue.selectedRoom.detail)
                            },
                            isScrollTop:isScrollTop,
                            lastMessage: vue.getContentIntoConvers(vue.selectedRoom.detail).lastMsg,
                            photo: result ? result.photo : null,
                            unreadMessageArray: unreadMessageArray,
                            isChangeMessage: vue.isChangeMessage
                        };
                       }
                  
                  } 

                } 
                setTimeout(()=> {
                  
                        vue.loadingChatDetail= false;
                   
                },1000)
                    this.isLoadingConversation = false;
                });
            
            }
        },
        snapshotToArray (snapshot) {
            const returnArr = [];
        
            snapshot.forEach((childSnapshot) => {
                const item = childSnapshot.val();
                if (item) {
                  item.key = childSnapshot.key;
                  returnArr.push(item);
                }
            });
        
            return returnArr;
        },
        onChangeMessage(event) {
            if (this.selectedRoom) {
                this.currentMess.sentAt = null;
                this.isChangeMessage = true;
                this.updateSelectedConvesationContent(false)
              if (
                this.arrayConversationInputMessage.findIndex(
                  item => item.id == this.selectedRoom.detail.id
                ) < 0 ||
                this.arrayConversationInputMessage.length == 0
              ) {
                this.arrayConversationInputMessage.push({
                  id: this.selectedRoom.detail.id,
                  message: event
                });
              } else {
                this.arrayConversationInputMessage.find(
                  item => item.id == this.selectedRoom.detail.id
                ).message = event;
              }
            }

          },
        updateFirstTimeSelectRoom(event) {
          this.selectedRoom.detail.isFirstOpenRoomchat = event;
        },
        getUnreadConversationCount() {
            chatService.getUnreadConversationCount().then((res)=> {
              this.numberUnreadConversation = res.numberOfUnreadConversation
            }
            )
          },
        ...mapActions('mission', ['getMissions']),
        ...mapActions('chat', ['getConversations', 'sendMsgToFirebase', 'sendPendingMsgs', 'setCurrentConversation','getNumberUnreadConversation']),
        ...mapActions({
            setProcessing: 'SET_LOADING'
        }),
        initConversation() {
            this.getConversations(this.userCrfId);
            firebase
                .database()
                .ref(".info/connected")
                .on("value", snapshot => {
                    this.isDisconnected = !snapshot.val();
                    if (snapshot.val() && this.conversations && this.conversations.length > 0) {
                        this.conversations.forEach(convers => {
                            this.sendPendingMsgs({path:this.refMessage + "/" + convers.idFirebase,conversationId:convers.id});
                        });

                    }
                });

        },
        openRoomChat(event, missionInfo) {
            this.showRoomChat = true;
            this.firebaseConversations = []
            this.isChangeMessage = false;
            event.isSelectedRoomchat = true;
            event.isFirstOpenRoomchat = false;
            if(this.conversations.length > 0 && this.selectedRoom && this.selectedRoom.detail) {
              this.conversations.find((item)=>item.id == this.selectedRoom.detail.id).isSelectedRoomchat = false;
              this.conversations.find((item)=>item.id == this.selectedRoom.detail.id).isFirstOpenRoomchat = false;
            }
            if(!this.selectedRoom || (this.selectedRoom &&event.id!==this.selectedRoom.detail.id)){
                this.currentMess = {sentAt:null}
                this.selectedRoom = {
                    detail: event
                };
                this.updateSelectedConvesationContent(false)
            }
          
        
            const index = this.arrayConversationInputMessage.findIndex(
                item => item.id == this.selectedRoom.detail.id
            );
              if (index >= 0) {
                this.selectedRoom.detail.inputMessage =
                  this.arrayConversationInputMessage &&
                  this.arrayConversationInputMessage[index].message
                    ? this.arrayConversationInputMessage[index].message
                    : "";
              }
            
            this.isOpenRoomChat = false;
            setTimeout(()=> {
             this.isOpenRoomChat = true;
            },1000)
            this.getMissionPhoto(missionInfo);
            this.getMemberStatus();
        },

        onReadConversation() {
            this.initConversation();
            
            this.getNumberUnreadConversation(this.userCrfId);

        },
        getMemberStatus() {
            /** Get member status **/
            firebase
                .database()
                .ref(`${this.refUser}`)
                .on("value", snapshot => {
                    snapshot.forEach(doc => {
                        if (doc.key === this.userIdFirebase) {
                            this.userStatus = doc.val().status;
                        }
                    });
                });
        },

        getMissionPhoto(missionInfo) {
            if (!this.selectedRoom.detail || !this.selectedRoom.detail.members) {
                return '';
            }
            const chatUserInfo = this.selectedRoom.detail.members.find(member =>
                member.idFirebase === missionInfo.idFirebase || `usr-${missionInfo.pkClient}`
            )
            this.selectedRoom['photo'] = chatUserInfo.picture;
        },

        groupBasedOnClient(data) {
            this.groupMissions = _.groupBy(data.filter(item => item.clientName), (v) => v.clientName);
            // Format group base on client in the first loading
            if (this.isFirstLoaded) {
                this.isFirstLoaded = false;
                let defaultIndex = 0;
                if (!conditionHelper('rcfchatadvteamclient') && this.groupMissionValues[0].length > 1) {
                    defaultIndex = this.groupMissionValues[0].findIndex(item => +item.type === ROOM_TYPE.TEAM)
                }
              
                if(this.agencyConversation) {
                    this.selectedRoom = {
                        detail: this.agencyConversation,
                        photo: this.agencyInfo ? this.agencyInfo.photo :null
                    };
                    this.selectedRoom.detail.isSelectedRoomchat= true;
                    this.getMemberStatus();
                } else {
                     this.selectedRoom = {
                     detail: this.groupMissionValues[0] && defaultIndex !== -1 ? this.groupMissionValues[0][defaultIndex] : {},
                };
                this.selectedRoom.detail.isSelectedRoomchat= true;
               
                this.getMissionPhoto(this.groupMissionValues[0]);
                this.getMemberStatus();
                }

                this.isOpenRoomChat = false;
                setTimeout(()=> {
                 this.isOpenRoomChat = true;
                },1000);
                
               
            }
        },

         

        async groupAgencyTeam(data) {
            const agencyConversation = data.find(room => room.type == ROOM_TYPE.AGENCY); // Find agency channel
            // Set default room if this adv didn't have any missions.
            if (agencyConversation) {
                this.agencyInfo = agencyConversation.members.find(member => {
                    return member.type == MEMBER_TYPE.AGENCY ||
                        member.type == MEMBER_TYPE.AGENCY_REFERER ||
                        member.type == MEMBER_TYPE.AGENCY_LEAD
                })
                this.agencyConversation = {
                    ...agencyConversation,
                    lastTime: await this.getDisplayTime(agencyConversation.id)
                    // ...this.getContentIntoConvers(agencyConversation)
                }

                if (!this.groupMissionValues.length || (!conditionHelper('rcfchatadvteamclient') && !conditionHelper('rcfchatadvteam'))) {
                    this.selectedRoom = {
                        detail: this.agencyConversation,
                        photo: this.agencyInfo ? this.agencyInfo.photo : null
                    };
                    this.getMemberStatus();
                };

            }
            this.groupBasedOnClient(data);
        },

        getContentIntoConvers(conversation) {
            const content = [];
            let lastMsg = '';
            if (this.firebaseConversations.length >0) {
                this.currentMess = Object.assign({}, this.firebaseConversations[0]);
                // const objectKeys = Object.keys(msgObject);
                lastMsg = this.firebaseConversations[this.firebaseConversations.length -1];
                this.firebaseConversations.forEach((conver,index) => {
                    const userInfo = conversation.members.find(member => member.idFirebase === conver.sentBy);
            
                    content.push({
                        ...conver,
                        userInfo: userInfo,
                        isMine: conver.sentBy === `usr-${this.userCrfId}`,
                        isLastMessage: index==this.firebaseConversations.length -1,
                    });
                })
            }


            return {
                lastMsg: lastMsg,
                content: content
            }

            
        },
        loadMoreMessage(val) {
           if(val){
            this.isLastMessage= false;
            this.updateSelectedConvesationContent(true)
           }
        },
        isChannelActive(data) {
            return this.selectedRoom && this.selectedRoom.detail.id === data.id;
        },
        unselectGroup() {
            this.selectedRoom = null;
        },

        getChatCharter() {
            chatService.getChatCharte().then((res)=> {
             if(res && res.data ) {
                this.isShowTchat = false;
                this.updateReachChatIcon();
               if(!res.data.dateSignature) {
                 this.showModal();                 
               } else if(res.data.dateSignature){
                  const numberDate = this.chatSettings && this.chatSettings.noOfRevalidationDays ? this.chatSettings.noOfRevalidationDays : 0;
                  if(numberDate >=0) {
                    const currentDate = new Date()
                    if(  moment(currentDate).valueOf()>= (res.data.dateSignature+numberDate *24*3600*1000)) {
                        this.showModal();
                    } else {
                        this.isShowTchat = true;
                    }
                  }
               }
             }
            }).catch((er)=> {
                this.isShowTchat = false;
                this.errorMessage = er;
            })
           },
       
           showModal() {
             this.$refs['confirmChatCharteModal'].show();
           },
           hideModal() {
             this.$refs['confirmChatCharteModal'].hide();
             this.updateReachChatIcon();
             this.isClickApplyTchat = false;
           },
       
           getBussinessSupport() {
             supportBusinessService.getList().then((res)=> {
               if(res && res.businessSupports){
                const tchatContent = res.businessSupports.find((item)=> item.keyword ==KEYWORDS.DEV_CHARTE);
                this.tchatContent = tchatContent ? tchatContent.content : '';
               }
             })
           },
           onConfirmPopup() {
            this.isClickApplyTchat = true;
            const data = {
                dateSignature: moment().valueOf()
            };
            chatService.updateChatCharte(data).then(()=> {
                this.hideModal();
                this.isShowTchat = true;
            }).catch(err=> {
                this.callToaster(
                    err.message
                );
                this.hideModal();
                this.isShowTchat = false;
            })
           },
           onHideModal() {
            if(!this.isClickApplyTchat) {
                this.updateReachChatIcon();
                this.isClickApplyTchat = false;
                this.$router.back();
            }
           
           },
           onRefuseCharte() {
            this.updateReachChatIcon();
            this.isClickApplyTchat = false;
            this.$router.back();
           },
           updateReachChatIcon() {
            if(this.isReachChatIcon) {
                this.$store.commit("chat/SET_REACH_CHAT_ICON",false)
              }
           },
           onShowTchatModal() {
            this.$refs['chatCharteModal'].show();

           },
           onHideTchatModal() {
            this.$refs['chatCharteModal'].hide();

           }
         
    }
}